import type { Locale, Translations } from './types'
import { messages as itITMessages } from './locales/it-IT'

export const fallbackLocale: Locale = 'it-IT'

export const localeLabels: Record<Locale, string> = {
  'it-IT': 'Italiano',
  'en-US': 'English (US)',
}

export const localeLoaders: Record<Locale, () => Promise<Translations>> = {
  'it-IT': () => import('./locales/it-IT').then(({ messages }) => messages),
  'en-US': () => import('./locales/en-US').then(({ messages }) => messages),
}

export const translations: Partial<Record<Locale, Translations>> = {
  'it-IT': itITMessages,
}

export const availableLocaleCodes = Object.keys(localeLabels) as Locale[]

const localeAliases: Record<string, Locale> = {
  it: 'it-IT',
  'it-it': 'it-IT',
  'it_it': 'it-IT',
  'it-it@euro': 'it-IT',
  en: 'en-US',
  'en-us': 'en-US',
  'en_us': 'en-US',
  'en-gb': 'en-US', // fallback to en-US until en-GB exists
}

export const normalizeLocale = (value?: string | null): Locale | null => {
  if (!value) return null
  const lower = value.toLowerCase()
  if (localeAliases[lower]) return localeAliases[lower]
  if (availableLocaleCodes.includes(value as Locale)) {
    return value as Locale
  }
  return null
}

export const loadLocaleMessages = async (locale: Locale): Promise<Translations> => {
  const cached = translations[locale]
  if (cached) return cached
  const messages = await localeLoaders[locale]()
  translations[locale] = messages
  return messages
}
